<template>
  <div class="container" style="background-color: #f2f7fd">
    <v-row>
      <v-col cols="12" class="d-flex">
        <img
          style="width: 40px; height: 40px; margin-right: 7px; mix-blend-mode: multiply"
          :src="require('../assets/ClarificationLogo.png')"
        />
        <span class="coreforce">Coreforce</span>
      </v-col>
      <v-col cols="6" style="margin-top: 40px" v-if="!isMobileView">
        <h1 class="headline">We Help in</h1>
        <h1 class="subheadline">
          <span class="highlight">Growing your<br />business</span>
        </h1>
        <p class="description description-text" style="margin-top: 110px">
          Our team of industry professionals take care of your day to day business needs allowing
          you to focus on unparalleled sales growth.
        </p>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="6"
        style="margin-top: 40px"
        class="d-flex"
        :class="{ 'justify-end pr-12': !isMobileView, 'justify-center': isMobileView }"
      >
      <v-form @submit.prevent="login" ref="form">
        <v-card width="330" class="login-card">
          <v-card-title class="login-title">Login</v-card-title>
          <v-card-text>
            <div>
            <v-error class="error" v-if="error"
              >Invalid Username And Password</v-error
            >
            </div>
            <v-text-field
              v-model="email"
              variant="outlined"
              placeholder="Your email"
              :rules="emailRule"
            ></v-text-field>
            <v-text-field
              v-model="password"
              variant="outlined"
              placeholder="Your password"
              type="password"
              :rules="passwordRule"
            ></v-text-field>
            <v-btn 
            block 
            color="#DD0E1A"
            :disabled="loading"
            type="submit"
            :loading="loading"
            >Login</v-btn>
            <h3 class="log-or"><span></span>OR <span></span></h3>
            <div class="text-center links mt-3">
              <v-btn variant="plain" class="forget" @click="$router.push('/forgetpassword')">Forgot your password ?</v-btn><br/>
              <a href="#">Trouble Signing in</a>
            </div>
          </v-card-text>
        </v-card>
      </v-form>
      </v-col>
      <v-col cols="12" xs="12" style="margin-top: 4px; text-align: center" v-if="isMobileView">
        <p class="description">
          Our team of industry professionals take care of your day to day business needs allowing
          you to focus on unparalleled sales growth.
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import userService from "../api/service/UserService.js";
import DynamodbModel from "@/api/service/Dynamodb/DynamodbService";
import store from '../store/index.js'

export default {
  data() {
    return {
      isMobileView: false,
      emailRule: [(value) => !!value || "Email is Required."],
      passwordRule: [(value) => !!value || "Password is Required."],
      loading:false,
      email:null,
      password:null,
      error:false
    };
  },
  components: {},
  created() {
      let data = {
        appId: process.env.VUE_APP_APP_ID,
        sessionId: this.$route.query.sessionId,
        redirectUrl: process.env.VUE_APP_REDIRECT_URL,
      };
      localStorage.setItem("APP_ID",process.env.VUE_APP_APP_ID);
      localStorage.setItem("login_details", JSON.stringify(data));
    let $data = JSON.parse(localStorage.getItem("login_details"));
    this.redirecturl = $data.redirectUrl;
    localStorage.setItem("REDIRECT_URL", this.redirecturl);
    this.appId = $data.appId;
    console.log(this.redirecturl, "aleertttt");
    this.getAppDetail();
    this.checkMobileView();

    window.addEventListener("resize", this.checkMobileView);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobileView);
  },
  methods: {
    checkMobileView() {
      this.isMobileView = window.innerWidth <= 600;
    },
    async getAppDetail() {
        let res = await DynamodbModel.AppDetails(process.env.VUE_APP_APP_ID);
        store.commit("SET_APP_DEDAILS", res);
        this.loading = false;
    },
    async login() {
      if (this.email && this.password) {
        try {
          this.loading = true;
          let response = await userService.fireBaseLogin({
            email: this.email,
            password: this.password,
            appId: process.env.VUE_APP_APP_ID,
          });

          if (response.token) {
            try {
              window.location = this.redirecturl + "?token=" + response.token;
            } catch (e) {
              this.error = true;
              this.loading = false;
              console.log(e);
            }
          }
        } catch (e) {
          this.error = true;
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding: 40px;
  background-image: url("/src/assets/background.svg");
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
}
.headline {
  /* font-family: Poppins; */
  font-size: 45px;
  font-weight: 400;
  line-height: 84px;
  color: #121212;
}
.subheadline {
  /* font-family: Poppins; */
  font-size: 65px;
  font-weight: 600;
  line-height: 75px;
}
.divider {
  margin-top: 20px;
  color: #000000;
}
.divider-text {
  /* font-family: Inter; */
  text-align: center;
  margin: 10px 0;
  color: #000000;
  font-size: 14px;
  font-weight: 400;
}
.highlight {
  color: #dd0e1a;
}
.login-title {
  /* font-family: Inter; */
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 5px;
}
.login-card {
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e2daf9;
}
.log-or {
  margin: 10px 0;
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
}
.log-or span {
  width: 100%;
  height: 1px;
  background-color: rgba(128, 128, 128, 0.189);
}
.links a {
  /* font-family: Inter; */
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  text-decoration: none;
}
.forget{
  cursor:pointer
}
.forget:hover{
  color:rgb(104, 104, 246);
  cursor:pointer
}
.coreforce {
  /* font-family: Quicksand; */
  font-size: 18px;
  font-weight: 700;
  color: #000000;
}
.description {
  /* font-family: Poppins; */
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #121212;
}
>>> .v-field__field {
  height: 35px !important;
}
>>> .v-field--variant-outlined,
.v-field--single-line,
.v-field--no-label {
  --v-field-padding-top: -200px !important;
}
@media screen and (max-width: 1020px) {
  .description-text {
    margin-top: 30px !important;
  }
}
</style>
